<script>
    import { writable } from 'svelte/store';
    import { setContext } from 'svelte';
    import { Database, aql } from 'arangojs/web';
    
    // --- Interface with the database
    const db = new Database({
        url: "http://localhost:8529",
        databaseName: "VAST",
        auth: { username: "jelmer", password: "w8w" },
    });


    // --- Helpers
    const _pass = v => v;
    const _store = {
        update: fun => {}
    };

    async function _query(db, q, store, fun) {
        let values = [];
        try {
            const cursor = await db.query(q);
            values = await cursor.all();
        } catch(err) {
            console.error(err.message);
        }
        // Apply the callback function
        values = fun(values);
        // Write values to the store
        store.update(() => values);
        return values;
    }

    
    // --- API
    function query(q, store=_store, fun=_pass) {
        return _query(db, q, store, fun);
    }
    
    function retrieve(q, fun=_pass) {
        const store = writable([]);
        _query(db, q, store, fun);
        return store;
    }

    // --- Set the context so slots can use the database
    const key = {};
    setContext(key, {
        retrieve, query, aql, db
    });

</script>

<slot {key}/>
